import { useState } from 'react';

function CarouselItemOne() {
  const [imgError, setImgError] = useState(false);
  return (
    <div className="flex-shrink-0 w-[280px] md:w-[340px] group bg-background-50 rounded-xl border border-background-200/70 overflow-hidden hover:border-primary-200 transition-all duration-300 cursor-default">
      <div className="aspect-[16/9] bg-background-100 relative overflow-hidden">
        {!imgError ? (
          <img
            src="https://readdy.ai/api/search-image?query=Artistic%20illustration%20of%20a%20romantic%20Korean%20comic%20scene%20with%20elegant%20characters%20in%20a%20royal%20palace%20ballroom%2C%20soft%20golden%20chandelier%20lighting%2C%20flowing%20gowns%20and%20suits%2C%20dreamy%20atmospheric%20composition%2C%20warm%20pink%20and%20gold%20color%20palette%2C%20professional%20editorial%20banner%20design&width=680&height=382&seq=carousel-01&orientation=landscape"
            alt="焦点专题 - 韩漫恋爱精选"
            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
            onError={() => setImgError(true)}
          />
        ) : (
          <div className="w-full h-full flex items-center justify-center text-foreground-400">
            <i className="ri-heart-line text-4xl"></i>
          </div>
        )}
        <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent"></div>
        <div className="absolute bottom-0 left-0 right-0 p-4">
          <span className="px-2 py-0.5 rounded-full bg-accent-500 text-background-50 text-xs font-medium">专题</span>
          <h3 className="text-base font-heading font-bold text-background-50 mt-2">韩漫恋爱精选</h3>
        </div>
      </div>
      <div className="p-4">
        <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">精选高分韩漫恋爱作品，从甜宠到虐心，每一部都是漫迷公认的必看佳作。</p>
      </div>
    </div>
  );
}

function CarouselItemTwo() {
  const [imgError, setImgError] = useState(false);
  return (
    <div className="flex-shrink-0 w-[280px] md:w-[340px] group bg-background-50 rounded-xl border border-background-200/70 overflow-hidden hover:border-primary-200 transition-all duration-300 cursor-default">
      <div className="aspect-[16/9] bg-background-100 relative overflow-hidden">
        {!imgError ? (
          <img
            src="https://readdy.ai/api/search-image?query=Artistic%20illustration%20of%20an%20epic%20fantasy%20battle%20scene%20with%20warriors%20wielding%20magical%20weapons%2C%20dramatic%20dynamic%20composition%20with%20energy%20effects%2C%20warm%20orange%20and%20crimson%20lighting%2C%20Japanese%20anime%20action%20style%2C%20professional%20editorial%20banner%20design&width=680&height=382&seq=carousel-02&orientation=landscape"
            alt="焦点专题 - 日漫热血排行"
            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
            onError={() => setImgError(true)}
          />
        ) : (
          <div className="w-full h-full flex items-center justify-center text-foreground-400">
            <i className="ri-fire-line text-4xl"></i>
          </div>
        )}
        <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent"></div>
        <div className="absolute bottom-0 left-0 right-0 p-4">
          <span className="px-2 py-0.5 rounded-full bg-accent-500 text-background-50 text-xs font-medium">排行</span>
          <h3 className="text-base font-heading font-bold text-background-50 mt-2">日漫热血排行</h3>
        </div>
      </div>
      <div className="p-4">
        <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">本季度最燃日漫热血作品集结，从经典续作到新番黑马一网打尽。</p>
      </div>
    </div>
  );
}

function CarouselItemThree() {
  const [imgError, setImgError] = useState(false);
  return (
    <div className="flex-shrink-0 w-[280px] md:w-[340px] group bg-background-50 rounded-xl border border-background-200/70 overflow-hidden hover:border-primary-200 transition-all duration-300 cursor-default">
      <div className="aspect-[16/9] bg-background-100 relative overflow-hidden">
        {!imgError ? (
          <img
            src="https://readdy.ai/api/search-image?query=Artistic%20illustration%20of%20a%20mysterious%20detective%20scene%20in%20a%20dimly%20lit%20library%20with%20floating%20clues%20and%20puzzle%20pieces%2C%20suspenseful%20atmosphere%20with%20warm%20amber%20lighting%2C%20clean%20Korean%20webtoon%20thriller%20style%2C%20professional%20editorial%20banner%20design&width=680&height=382&seq=carousel-03&orientation=landscape"
            alt="焦点专题 - 悬疑漫画推理"
            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
            onError={() => setImgError(true)}
          />
        ) : (
          <div className="w-full h-full flex items-center justify-center text-foreground-400">
            <i className="ri-search-eye-line text-4xl"></i>
          </div>
        )}
        <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent"></div>
        <div className="absolute bottom-0 left-0 right-0 p-4">
          <span className="px-2 py-0.5 rounded-full bg-accent-500 text-background-50 text-xs font-medium">专题</span>
          <h3 className="text-base font-heading font-bold text-background-50 mt-2">悬疑漫画推理</h3>
        </div>
      </div>
      <div className="p-4">
        <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">烧脑悬疑漫画特辑，反转不断的剧情让你欲罢不能，推理迷必收藏。</p>
      </div>
    </div>
  );
}

function CarouselItemFour() {
  const [imgError, setImgError] = useState(false);
  return (
    <div className="flex-shrink-0 w-[280px] md:w-[340px] group bg-background-50 rounded-xl border border-background-200/70 overflow-hidden hover:border-primary-200 transition-all duration-300 cursor-default">
      <div className="aspect-[16/9] bg-background-100 relative overflow-hidden">
        {!imgError ? (
          <img
            src="https://readdy.ai/api/search-image?query=Artistic%20illustration%20of%20a%20beautiful%20ancient%20Chinese%20landscape%20with%20misty%20mountains%20and%20flowing%20waterfalls%2C%20traditional%20ink%20wash%20painting%20blended%20with%20modern%20manhua%20art%20style%2C%20warm%20earthy%20golden%20tones%2C%20elegant%20composition%2C%20professional%20editorial%20banner%20design&width=680&height=382&seq=carousel-04&orientation=landscape"
            alt="焦点专题 - 国漫古风力作"
            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
            onError={() => setImgError(true)}
          />
        ) : (
          <div className="w-full h-full flex items-center justify-center text-foreground-400">
            <i className="ri-landscape-line text-4xl"></i>
          </div>
        )}
        <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent"></div>
        <div className="absolute bottom-0 left-0 right-0 p-4">
          <span className="px-2 py-0.5 rounded-full bg-accent-500 text-background-50 text-xs font-medium">专题</span>
          <h3 className="text-base font-heading font-bold text-background-50 mt-2">国漫古风力作</h3>
        </div>
      </div>
      <div className="p-4">
        <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">国风漫画的视觉盛宴，水墨丹青与现代分镜的完美结合，展现东方美学。</p>
      </div>
    </div>
  );
}

function CarouselItemFive() {
  const [imgError, setImgError] = useState(false);
  return (
    <div className="flex-shrink-0 w-[280px] md:w-[340px] group bg-background-50 rounded-xl border border-background-200/70 overflow-hidden hover:border-primary-200 transition-all duration-300 cursor-default">
      <div className="aspect-[16/9] bg-background-100 relative overflow-hidden">
        {!imgError ? (
          <img
            src="https://readdy.ai/api/search-image?query=Artistic%20illustration%20of%20a%20cozy%20reading%20nook%20with%20colorful%20comic%20books%20scattered%20around%2C%20warm%20sunlight%20streaming%20through%20a%20window%2C%20comfortable%20cushions%20and%20a%20warm%20beverage%2C%20relaxing%20atmosphere%20with%20soft%20golden%20lighting%2C%20illustrative%20editorial%20style%2C%20professional%20banner%20design&width=680&height=382&seq=carousel-05&orientation=landscape"
            alt="焦点专题 - 免费全集漫画清单"
            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
            onError={() => setImgError(true)}
          />
        ) : (
          <div className="w-full h-full flex items-center justify-center text-foreground-400">
            <i className="ri-book-open-line text-4xl"></i>
          </div>
        )}
        <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent"></div>
        <div className="absolute bottom-0 left-0 right-0 p-4">
          <span className="px-2 py-0.5 rounded-full bg-accent-500 text-background-50 text-xs font-medium">清单</span>
          <h3 className="text-base font-heading font-bold text-background-50 mt-2">免费全集漫画清单</h3>
        </div>
      </div>
      <div className="p-4">
        <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">已完结高分漫画一次看完，完整版全集免费阅读，追漫不等待的最佳选择。</p>
      </div>
    </div>
  );
}

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-16 md:py-20 bg-background-100">
      <div className="px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            焦点专题
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-[560px] mx-auto">
            精选热门漫画专题合集，按主题一站直达你最感兴趣的内容
          </p>
        </div>

        <div className="flex gap-4 md:gap-5 overflow-x-auto pb-2 scrollbar-hide">
          <CarouselItemOne />
          <CarouselItemTwo />
          <CarouselItemThree />
          <CarouselItemFour />
          <CarouselItemFive />
        </div>

        <style>{`
          .scrollbar-hide::-webkit-scrollbar { display: none; }
          .scrollbar-hide { -ms-overflow-style: none; scrollbar-width: none; }
        `}</style>
      </div>
    </section>
  );
}